import { Outlet } from 'react-router-dom';

const Blank = (): JSX.Element => {
  return (
    <div className="flex bg-white">
      <Outlet />
    </div>
  );
};

export default Blank;
